import React, { useEffect, useState } from 'react';
import SystemApiService from '../../services/api/SystemApiService';
import GeneralHelper from '../Helpers/GeneralHelper';
import './EnvironmentLabel.scss';

const EnvironmentLabel: React.FC = () => {
  const [appInfo, setAppInfo] = useState<System_AppInformation_ViewModel>();

  useEffect(() => {
    const loadData = async () => {
      try {
        // In the dev / staging environments, we want to get app info, so we know which database we're pointing to on the server
        // and can show something in the UI when it's pointing to production
        if (GeneralHelper.isDevelopmentEnvironment() || GeneralHelper.isStagingEnvironment()) {
          const result = await SystemApiService.getAppInformation();
          setAppInfo(result);
        }
      } catch {}
    };
    loadData();
  }, []);

  const getLabelString = () => {
    const textParts: string[] = [];

    const production = 'Production';
    const staging = 'Staging';

    switch (appInfo?.dbEnvironment) {
      case production:
        textParts.push('production database');
        break;

      case staging:
        textParts.push('staging database');
        break;
    }

    // NOTE: We don't have staging S3 buckets.
    // The staging environment points to production S3 buckets.
    switch (appInfo?.s3_Files_Environment) {
      case production:
        textParts.push('production S3 bucket');
        break;
    }

    return textParts.length ? `Using ${textParts.join(' and ')}.` : '';
  };

  return (
    <>
      {getLabelString().length ? (
        <div className="environmentLabel">
          <div>{getLabelString()}</div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default EnvironmentLabel;
